"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemVanityClassesText = void 0;
const Class_1 = require("../classes/Class");
const definables_1 = require("definables");
const getItemVanityClasses_1 = require("./getItemVanityClasses");
const getItemVanityClassesText = (itemID) => {
    const classes = (0, getItemVanityClasses_1.getItemVanityClasses)(itemID);
    if ((0, definables_1.getDefinablesCount)(Class_1.Class) === classes.length) {
        return "All";
    }
    return classes
        .map((classObject) => classObject.abbreviation)
        .join(", ");
};
exports.getItemVanityClassesText = getItemVanityClassesText;
